import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

// localStorage key used to drive founder-mode "act as another user"
// impersonation. Read by an axios interceptor on every outbound
// request and surfaced to the backend via the X-Impersonate-User-Id
// header. Cleared when the founder exits impersonation.
export const IMPERSONATE_STORAGE_KEY = "ekselens.impersonate_user_id";

// Shared axios instance that always sends credentials (httpOnly session_token cookie)
const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

// Impersonation header — read at request-time so toggling reflects
// immediately without page reload.
api.interceptors.request.use((config) => {
  try {
    const target = window.localStorage.getItem(IMPERSONATE_STORAGE_KEY);
    if (target) {
      config.headers = { ...(config.headers || {}), "X-Impersonate-User-Id": target };
    }
  } catch {
    /* localStorage unavailable — no-op */
  }
  return config;
});

export const startImpersonation = (userId) => {
  try {
    window.localStorage.setItem(IMPERSONATE_STORAGE_KEY, userId);
  } catch {
    /* noop */
  }
};

export const stopImpersonation = () => {
  try {
    window.localStorage.removeItem(IMPERSONATE_STORAGE_KEY);
  } catch {
    /* noop */
  }
};

export const currentImpersonationTarget = () => {
  try {
    return window.localStorage.getItem(IMPERSONATE_STORAGE_KEY);
  } catch {
    return null;
  }
};

export default api;
export const API_BASE = `${BASE}/api`;
